// extracted by mini-css-extract-plugin
export default {"coupon-preview-modal-container":"CouponPreview_coupon-preview-modal-container__XOk77","coupon-price-details":"CouponPreview_coupon-price-details__6Ll1T"};